import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { BookOpen, Settings, Users, FolderTree, Factory, Database, Globe, Bell, ScrollText } from 'lucide-react';
import { GuideVotesWidget } from './GuideVotesWidget';

const GUIDE_SECTIONS = [
  { key: 'GettingStarted', icon: BookOpen },
  { key: 'Scenarios', icon: Settings },
  { key: 'Users', icon: Users },
  { key: 'Categories', icon: FolderTree },
  { key: 'External', icon: Factory },
  { key: 'Import', icon: Database },
  { key: 'Dashboard', icon: Globe },
  { key: 'Notifications', icon: Bell },
  { key: 'Audit', icon: ScrollText },
];

export const AdminGuideTab = ({ t }) => (
  <div className="space-y-6">
    <GuideVotesWidget t={t} />
    <Card>
    <CardHeader>
      <CardTitle>{t('admin.guideTitle')}</CardTitle>
      <CardDescription>{t('admin.guideDesc')}</CardDescription>
    </CardHeader>
    <CardContent>
      <div className="space-y-4" data-testid="admin-guide-content">
        {GUIDE_SECTIONS.map(({ key, icon: Icon }) => {
          const steps = t(`admin.guide${key}Steps`, { returnObjects: true });
          const tip = t(`admin.guide${key}Tip`, { defaultValue: '' });
          return (
            <details key={key} className="group border rounded-lg" data-testid={`guide-section-${key}`}>
              <summary className="flex items-center gap-3 p-4 cursor-pointer hover:bg-muted/50 rounded-lg transition-colors font-semibold">
                <Icon className="h-5 w-5 text-orange-500 shrink-0" />
                {t(`admin.guide${key}`)}
              </summary>
              <div className="px-4 pb-4 pt-2 pl-12 space-y-3">
                <p className="text-sm text-muted-foreground leading-relaxed">{t(`admin.guide${key}Text`)}</p>
                {Array.isArray(steps) && steps.length > 0 && (
                  <ol className="list-decimal list-inside text-sm text-muted-foreground space-y-1.5 pl-1">
                    {steps.map((s, i) => <li key={i} className="leading-relaxed">{s}</li>)}
                  </ol>
                )}
                {tip && (
                  <div className="bg-orange-50 dark:bg-orange-950/20 border border-orange-200 dark:border-orange-800 rounded-md px-3 py-2 text-xs text-orange-800 dark:text-orange-300">
                    <strong>Tipp:</strong> {tip}
                  </div>
                )}
              </div>
            </details>
          );
        })}
      </div>
    </CardContent>
  </Card>
  </div>
);
